import { z } from "zod";

export const MINIMUM_PASSWORD_PATTERN = /^.{8,}$/;
export const UPPERCASE_PATTERN = /^(?=.*[A-Z])/;
export const LOWERCASE_PATTERN = /^(?=.*[a-z])/;
export const INTEGER_PATTERN = /^(?=.*\d)/;
export const SYMBOL_PATTERN = /[$&+,:;=?@#|'<>.^*()%!-]/;
export const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$&+,:;=?@#|'<>.^*()%!-])[a-zA-Z\d$&+,:;=?@#|'<>.^*()%!-]{8,}$/;
export const NUMBER_PATTERN = /^[0-9]{6}$/;

const PASSWORD_SCHEMA = z
  .string({ required_error: "Password is required" })
  .min(8, "Password must be at least 8 characters long")
  .regex(
    UPPERCASE_PATTERN,
    "Password must contain at least one uppercase letter",
  )
  .regex(
    LOWERCASE_PATTERN,
    "Password must contain at least one lowercase letter",
  )
  .regex(INTEGER_PATTERN, "Password must contain at least one number")
  .regex(
    SYMBOL_PATTERN,
    "Password must contain at least one special character",
  );

const BASE_PASSWORD_SCHEMA = z.object({
  password: PASSWORD_SCHEMA,
  confirmPassword: z.string({ required_error: "Confirm Password is required" }),
});

// Ensure password confirmation validation
const PASSWORD_CONFIRMATION_SCHEMA = BASE_PASSWORD_SCHEMA.refine(
  (data) => data.password === data.confirmPassword,
  {
    message: "Passwords do not match.",
    path: ["confirmPassword"],
  },
);

export const FORM_SCHEMA_REGISTER = z
  .object({
    email: z
      .string({ required_error: "Email is required" })
      .email({ message: "Invalid email address" }),
    otp_number: z
      .string({ required_error: "Code is required" })
      .max(6, { message: "Number must contain at most 6 character(s)" }),
  })
  .extend(BASE_PASSWORD_SCHEMA.shape) // Ensure type compatibility
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match.",
    path: ["confirmPassword"],
  });

export const FORM_SCHEMA_PASSWORD = PASSWORD_CONFIRMATION_SCHEMA;
